<nav class="navbar navbar-expand-lg navbar-dark bg-dark static-top admin-header">
    <div class="container">
        <a class="navbar-brand">
            <img class="img-thumbnail chamber-image" src="assets/images/{{epimelitirio}}.jpg" alt="Logo">
        </a>
        <div class="navbar-nav ml-auto">
            <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive"
                aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button> -->
            <div id="navbarResponsive">
                <ul *ngIf="authService.isAdminFunc() && adminUsername" class="navbar-nav ml-auto">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
                        {{adminUsername}}
                    </a>
                        <div style="cursor: pointer;" class="dropdown-menu dropdown-menu-right">
                            <a class="dropdown-item" (click)="candidatesHandling(keycloakId)">Διαχείριση Υποψηφίων</a>
                            <a [routerLink]="['/administrator/companyHandling']" class="dropdown-item my-links">Διαχείριση Εταιρειών</a>
                            <a [routerLink]="['/administrator/jobPostHandling']" class="dropdown-item my-links">Διαχείριση Θέσεων Εργασίας</a>
                            <a class="dropdown-item" (click)="signout()"><span
                                class="icon mdi mdi-logout"></span>Αποσύνδεση</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</nav>